const buttonPaddingMap = {
    tiny: { padding: 16, paddingRight: 12, iconSpacing: 8, height: 32 },
    small: { padding: 16, paddingRight: 12, iconSpacing: 10, height: 36 },
    standard: { padding: 24, paddingRight: 16, iconSpacing: 10, height: 40 },
    touch: { padding: 24, paddingRight: 16, iconSpacing: 12, height: 44 },
    big: { padding: 24, paddingRight: 16, iconSpacing: 14, height: 48 },
    huge: { padding: 32, paddingRight: 24, iconSpacing: 18, height: 60 },
};
const isFlatStylingType = (value) => value.startsWith("flat");
export const buttonSpacing = (size, stylingType) => isFlatStylingType(stylingType)
    ? Object.assign(Object.assign({}, buttonPaddingMap[size]), { padding: size === "huge" ? 20 : 16, paddingRight: size === "huge" ? 20 : 16 }) : buttonPaddingMap[size];
